<section class="grid grid-2 hero">
  <div class="hero-copy">
    <div class="badge typewriter">
      <span>Juego de misterio</span>
      <span>•</span>
      <span>Años 20</span>
    </div>

    <h1>
      Murder Nights
      <span class="subhead">Atrapa, acusa y sobrevive en la mansión.</span>
    </h1>

    <p class="lead">
      Murder Nights es un juego de roles ocultos ambientado en una mansión de los años 20. Cada jugador es un miembro de la familia Thompson o alguien de su servicio; algunos actuarán como detectives, otros como asesinos. Decide a quién creer antes de que te acusen: es un cluedo en vivo, pero con objetivos cruzados y miradas que lo dicen todo.
    </p>

    <div class="lore card">
      <div class="section-title">
        <h3>La herencia Thompson</h3>
      </div>
      <p class="muted">
        La primoabuela de tu tía ha dejado una fortuna multimillonaria a la familia Thompson, de la que formas parte. Todos habéis sido invitados a su lujosa mansión para leer la herencia. La codicia es desmedida: cada miembro hará lo que sea por quedarse con todo.
      </p>
    </div>

    <div class="hero-metas">
      <span class="meta-chip">5-12 jugadores</span>
      <span class="meta-chip">Partidas en segundo plano (horas o días)</span>
      <span class="meta-chip">Intriga + acusaciones públicas</span>
    </div>

    <div class="hero-actions">
      <a routerLink="/comprar">
        <button class="btn-primary">
          Reservar ahora
          <span class="pill">desde 24,90 €</span>
        </button>
      </a>
      <span class="hint typewriter">Las sospechas crecen con cada conversación. ¿Quién miente?</span>
    </div>

    <div class="callout card">
      <div class="section-title">
        <h3>Objetivo de la noche</h3>
      </div>
      <p class="muted">
        Localiza a tu objetivo, consigue el arma y controla el lugar clave. Elimina la competencia y quédate con toda la herencia antes de que alguien te delate.
      </p>
    </div>
  </div>

  <div class="hero-art">
    <div class="photo-frame">
      <img src="assets/images/deco/mansion.png" alt="Mansión Murder Nights" loading="lazy" />
      <div class="photo-caption typewriter">La mansión Thompson: seda, jazz y la sombra de la codicia.</div>
    </div>

    <div class="card-fan">
      <img class="fan-card fan-1" [class.active]="selectedCard === 'dorsal'" (click)="toggleCard('dorsal')" src="assets/images/cartas/dorsal_card.png" alt="Reverso de las cartas" loading="lazy" />
      <img class="fan-card fan-2" [class.active]="selectedCard === 'mozo'" (click)="toggleCard('mozo')" src="assets/images/cartas/mozo_card.png" alt="Carta de personaje: Mozo" loading="lazy" />
      <img class="fan-card fan-3" [class.active]="selectedCard === 'salon'" (click)="toggleCard('salon')" src="assets/images/cartas/salon_card.png" alt="Carta de lugar: Salón" loading="lazy" />
      <img class="fan-card fan-4" [class.active]="selectedCard === 'nina'" (click)="toggleCard('nina')" src="assets/images/cartas/ninya_card.png" alt="Carta de personaje: Niña" loading="lazy" />
      <img class="fan-card fan-5" [class.active]="selectedCard === 'higenico'" (click)="toggleCard('higenico')" src="assets/images/cartas/higenico_card.png" alt="Carta de arma: Papel higiénico" loading="lazy" />
    </div>

    <div class="deco-row">
      <img src="assets/images/deco/cuchillo.png" alt="Cuchillo" loading="lazy" />
      <img src="assets/images/deco/gato.png" alt="Gato" loading="lazy" />
      <img src="assets/images/deco/hall.png" alt="Hall" loading="lazy" />
      <img src="assets/images/deco/zapato.png" alt="Zapato" loading="lazy" />
      <img src="assets/images/deco/taza.png" alt="Taza" loading="lazy" />
    </div>
  </div>
</section>

<section class="card steps">
  <div class="section-title">
    <h2>Cómo se vive la partida</h2>
  </div>
  <div class="grid steps-grid">
    <div class="step">
      <p class="step-label typewriter">Preparación</p>
      <p class="muted">Cada jugador recibe en secreto un personaje, un objetivo, un arma cotidiana y un lugar de la mansión.</p>
    </div>
    <div class="step">
      <p class="step-label typewriter">Interactúa</p>
      <p class="muted">Negocia, haz corrillos y mide la información que compartes. No todos son aliados.</p>
    </div>
    <div class="step">
      <p class="step-label typewriter">Atrapa</p>
      <p class="muted">Reúne pistas, observa contradicciones y decide cuándo lanzar una acusación pública.</p>
    </div>
    <div class="step">
      <p class="step-label typewriter">Elimina</p>
      <p class="muted">Si aciertas, la competencia cae. Si fallas demasiado, la mansión te expulsa.</p>
    </div>
  </div>
</section>

<section class="grid grid-2 details">
  <div class="card detail-card">
    <div class="section-title">
      <h2>Ambiente noir</h2>
    </div>
    <p class="muted">
      Inspirado en los años 20: luz de lámparas, humo, jazz y susurros. El tono monocromo realza pistas clave. Las armas son objetos cotidianos convertidos en amenazas improvisadas.
    </p>
    <div class="meta-grid">
      <div>
        <p class="typewriter label">Tiempo</p>
        <p>De 1 hora a varios días si jugáis en segundo plano.</p>
      </div>
      <div>
        <p class="typewriter label">Jugadores</p>
        <p>De 5 hasta 12 invitados a la mansión.</p>
      </div>
    </div>
  </div>

  <div class="card detail-card">
    <div class="section-title">
      <h2>Mecánicas clave</h2>
    </div>
    <div class="sample-grid mechanics">
      <div class="sample">
        <p class="typewriter label">Roles ocultos</p>
        <p class="caption">Detectives y asesinos conviven; la lealtad rara vez es evidente.</p>
      </div>
      <div class="sample">
        <p class="typewriter label">Acusaciones públicas</p>
        <p class="caption">Apuesta tu reputación: errar demasiado te deja fuera del juego.</p>
      </div>
      <div class="sample">
        <p class="typewriter label">Objetivos cruzados</p>
        <p class="caption">El arma y el lugar importan tanto como la identidad de tu objetivo.</p>
      </div>
      <div class="sample">
        <p class="typewriter label">Partidas largas</p>
        <p class="caption">Ideal para viajes: avanza por escenas en lugar de turnos apresurados.</p>
      </div>
    </div>
  </div>
</section>

<section class="card gallery">
  <div class="section-title">
    <h2>Rostros en la mansión</h2>
  </div>
  <div class="gallery-grid">
    <figure class="gallery-item">
      <img src="assets/images/deco/esposa.png" alt="Esposa de la familia" loading="lazy" />
      <figcaption class="caption">La esposa, siempre cerca del testamento y de los secretos.</figcaption>
    </figure>
    <figure class="gallery-item">
      <img src="assets/images/deco/mayordomo.png" alt="Mayordomo" loading="lazy" />
      <figcaption class="caption">El mayordomo, que escucha todo en el pasillo principal.</figcaption>
    </figure>
  </div>
</section>

<section class="card contact">
  <div class="section-title">
    <h2>Contacto</h2>
  </div>
  <p class="muted">¿Tienes dudas, quieres reservas de grupo o avisos de la próxima tirada? Escríbenos.</p>
  <div class="contact-actions">
    <a class="contact-chip" href="mailto:murdernights@gmail.com">murdernights&#64;gmail.com</a>
  </div>
</section>
